import { render, staticRenderFns } from "./columnSortModal.vue?vue&type=template&id=7233d61a&scoped=true&"
import script from "./columnSortModal.vue?vue&type=script&lang=js&"
export * from "./columnSortModal.vue?vue&type=script&lang=js&"
import style0 from "./columnSortModal.vue?vue&type=style&index=0&id=7233d61a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7233d61a",
  null
  
)

export default component.exports